(ns machtfit.product-form.how
  (:require [clojure.string :as str]
            [com.rpl.specter :as sp]
            [machtfit.core :as machtfit]
            [machtfit.dashboard-widgets :as widgets]
            [machtfit.product-form.core :as product-form]
            [machtfit.product-form.review :as review]
            [machtfit.product-form.section :refer [show-next-section]]
            [machtfit.product-form.validation :as validation]
            [re-frame.core :as rf]))

(defn- registration-needed []
  [:div.valign-wrapper {:style {:margin-bottom "1rem"}}
   [widgets/choice
    {:name "registration-needed?"
     :intro "Eine Anmeldung ist"
     :current-choice @(rf/subscribe [:get [:product :how :registration-needed?]])
     :choices [[true "erforderlich."]
               [false "nicht erforderlich."]]
     :on-select #(rf/dispatch [:set-path [:product :how :registration-needed?] %])}]])

(defn- registration-type []
  [:div.valign-wrapper {:style {:margin-bottom "1rem"}}
   [widgets/choice
    {:name "registration-type"
     :intro "Die Anmeldung erfolgt"
     :current-choice @(rf/subscribe [:get [:product :how :registration-type]])
     :choices [[:machtfit "über machtfit."]
               [:external "anderweitig."]
               [:url "über einen externen Service."]]
     :on-select #(rf/dispatch [:set-path [:product :how :registration-type] %])}]])

(defn- registration-configuration-ro []
  (let [registration-needed? @(rf/subscribe [:get [:product :how :registration-needed?]])]
    [:div "Eine Anmeldung ist "
     [:b (case registration-needed?
           false "nicht erforderlich."
           true "erforderlich.")]
     " "
     (when (true? registration-needed?)
       [:span "Die Anmeldung erfolgt "
        [:b (case @(rf/subscribe [:get [:product :how :registration-type]])
              :machtfit "über machtfit."
              :external "nicht über machtfit."
              :url "über einen externen Service.")]])]))

(rf/reg-event-db ::set-user-info-explanation-text
  (fn [db [_ new-user-info-explanation-text]]
    (-> db
        (assoc-in [:product :how :user-info-explanation-text] new-user-info-explanation-text)
        (assoc-in [:ui :last-focused-config-section] nil))))

(rf/reg-event-db ::add-empty-extra-info-field
  (fn [db _]
    (update-in db [:product :how :extra-info-fields] conj {})))

(rf/reg-event-db ::set-extra-info-field-name
  (fn [db [_ index value]]
    (assoc-in db [:product :how :extra-info-fields index :value] value)))

(rf/reg-event-db ::delete-extra-info-field
  (fn [db [_ index]]
    (sp/setval [:product :how :extra-info-fields index] sp/NONE db)))

(rf/reg-event-db ::set-answer
  (fn [db [_ index subindex value]]
    (assoc-in db [:product :how :extra-info-fields index :answers subindex] value)))

(rf/reg-event-db ::add-answer
  (fn [db [_ index]]
    (sp/transform [:product :how :extra-info-fields index :answers sp/NIL->VECTOR] #(conj % "") db)))

(rf/reg-event-db ::set-answer-given?
  (fn [db [_ index]]
    (-> db
        (update-in [:product :how :extra-info-fields index :answer-given?] not)
                   ;; make sure answers is a vector and not a hash map
        (update-in [:product :how :extra-info-fields index :answers] #(or %1 [""])))))

(rf/reg-event-db ::toggle-required?
  (fn [db [_ index]]
    (update-in db [:product :how :extra-info-fields index :required?] not)))

(rf/reg-event-db ::delete-answer
  (fn [db [_ index subindex]]
    (sp/setval [:product :how :extra-info-fields index :answers subindex] sp/NONE db)))

(rf/reg-sub ::product-how-extra-info-fields-n
  :<- [:get [:product :how :extra-info-fields]]

  (fn [product-how-extra-info-fields [_ n]]
    (get product-how-extra-info-fields n)))

(rf/reg-sub ::product-how-extra-info-fields-n-answers
  (fn [[_ n]]
    [(rf/subscribe [::product-how-extra-info-fields-n n])])

  (fn [[question] _]
    (:answers question)))

(rf/reg-sub ::answer-is-duplicate?
  (fn [[_ index _subindex]]
    [(rf/subscribe [::product-how-extra-info-fields-n-answers index])])

  (fn [[answers] [_ _index subindex]]
    (let [answer (get answers subindex)]
      (and (not (str/blank? answer))
           (->> (subvec answers 0 subindex)
                (some #{answer})
                nil?
                not)))))

(defn- given-answers-input [index subindex current-count value]
  (let [is-duplicate? @(rf/subscribe [::answer-is-duplicate? index subindex])]
    [:span
     (str (inc subindex) ". ")
     [widgets/inline-input
      {:placeholder "Antwort"
       :value value
       :style {:width "50%"
               :text-align "left"}
       :on-save #(rf/dispatch [::set-answer index subindex %])}]
     (when (> current-count 1)
       [:a.waves-effect {:href "#"
                         :style {:cursor "pointer"
                                 :margin-left "0.5rem"
                                 :font-size "0.8rem"}
                         :on-click (comp #(rf/dispatch [::delete-answer index subindex]) machtfit/stop-event)}
        "Antwort löschen"])
     (when is-duplicate?
       [:a.orange-text {:style {:margin-left "0.5rem"
                                :font-size "0.8rem"}}
        "Duplikat wird ignoriert."])]))

(rf/reg-sub ::product-how-extra-info-fields-n-answer-given?
  (fn [[_ n]]
    [(rf/subscribe [::product-how-extra-info-fields-n n])])

  (fn [[question] _]
    (:answer-given? question)))

(rf/reg-sub ::product-how-extra-info-fields-n-required?
  (fn [[_ n]]
    [(rf/subscribe [::product-how-extra-info-fields-n n])])

  (fn [[question] _]
    (:required? question)))

(defn- given-answers [index]
  (let [required? @(rf/subscribe [::product-how-extra-info-fields-n-required? index])
        answers @(rf/subscribe [::product-how-extra-info-fields-n-answers index])
        answer-given? @(rf/subscribe [::product-how-extra-info-fields-n-answer-given? index])
        current-answers (if (empty? answers) [""] answers)]
    [:<>
     [:div {:style {:display "flex" :justify-content "start"}}
      [:input.filled-in
       {:type "checkbox"
        :id (str "extra-info-required-" index)
        :checked required?
        :on-change #(rf/dispatch [::toggle-required? index])}]
      [:label.black-text {:for (str "extra-info-required-" index)
                          :style {:margin-right "3rem"}} "Pflichtantwort"]
      [:input.filled-in
       {:type "checkbox"
        :id (str "extra-info-answer-given-" index)
        :checked answer-given?
        :on-change #(rf/dispatch [::set-answer-given? index])}]
      [:label.black-text {:for (str "extra-info-answer-given-" index)} "Antwortmöglichkeiten vorgeben"]]
     (when answer-given?
       [:table {:style {:margin-left "2rem"}}
        [:tbody
         (for [[subindex value] (map-indexed vector current-answers)]
           ^{:key (str "answer-" index "-" subindex)}
           [:tr
            [:td {:style {:padding-bottom 0}}
             [given-answers-input index subindex (count current-answers) value]]])
         [:tfoot
          [:tr
           [:td
            [:a.waves-effect {:href "#"
                              :style {:cursor "pointer"
                                      :font-size "0.8rem"}
                              :on-click (comp #(rf/dispatch [::add-answer index]) machtfit/stop-event)}
             "Antwort hinzufügen"]]]]]])]))

(rf/reg-sub ::product-how-extra-info-fields-n-value
  (fn [[_ n]]
    [(rf/subscribe [::product-how-extra-info-fields-n n])])

  (fn [[question] _]
    (:value question)))

(defn- extra-info-fields-input [index]
  [:span
   (str (inc index) ". ")
   [widgets/inline-input
    {:placeholder "Feldname"
     :value @(rf/subscribe [::product-how-extra-info-fields-n-value index])
     :on-save #(rf/dispatch [::set-extra-info-field-name index %])
     :style {:text-align "left"
             :width "50%"
             :margin-top "1rem"}}]])

(rf/reg-sub ::extra-info-fields-count
  :<- [:get [:product :how :extra-info-fields]]

  (fn [product-how-extra-info-fields _]
    (count product-how-extra-info-fields)))

(defn- extra-info-fields []
  (let [num-fields @(rf/subscribe [::extra-info-fields-count])]
    [:div
     "Bitte geben Sie an, welche Angaben der Teilnehmer machen soll (z.B. Telefonnummer, Verfügbarkeit):"
     (doall
      (for [index (range num-fields)]
        ^{:key index}
        [:div
         [extra-info-fields-input index]
         (when (> num-fields 1)
           [:button.waves-effect.btn.btn-flat
            {:style {:margin-left "0.5rem"
                     :padding "0 0.8rem"}}
            [:i.material-icons.left
             {:style {:margin-right "0"}
              :on-click #(rf/dispatch [::delete-extra-info-field index])}
             "delete"]])
         [given-answers index]]))
     (when (< num-fields 9)
       [:button.waves-effect.waves-light.btn
        {:on-click #(rf/dispatch [::add-empty-extra-info-field])
         :style {:margin-top "1rem"}} "Feld hinzufügen"])]))

(defn- require-user-info []
  (let [require-user-info? @(rf/subscribe [:get [:product :how :require-user-info]])
        machtfit-admin? @(rf/subscribe [::product-form/machtfit-admin?])
        company-product? @(rf/subscribe [:get [:options :company-product?]])]
    (when (or company-product?
              machtfit-admin?)
      [:div
       [:div {:style {:margin-bottom "1rem"}}
        [:hr]
        [:p
         "Sie können die Teilnehmer um freiwillige sowie Pflicht-Angaben bitten (z.B. ihre Telefonnummer oder Verfügbarkeit), "
         "wenn dies für die Terminplanung oder Rückfragen nötig ist."]
        [:input.filled-in {:type "checkbox"
                           :id "require-user-info"
                           :checked require-user-info?
                           :on-change #(rf/dispatch [:toggle [:product :how :require-user-info]])}]
        [:label.black-text {:for "require-user-info"
                            :style {:height "auto"
                                    :line-height "normal"}}
         "bei Anmeldung weitere Angaben abfragen"]]

       (when require-user-info?
         [:div
          [:div
           [:p "Bitte erläutern Sie, wofür die Angaben benötigt werden. Dieser Text wird dem Teilnehmer bei der Anmeldung angezeigt."]]
          [:div {:style {:margin-bottom "1rem"}}
           [:div {:style {:padding-top "1rem" :padding-bottom "1rem"}}
            [:div.input-field [:label.active {:style {:padding-bottom "0.4rem"}}
                               "Erklärung"]]
            [widgets/quill {:value @(rf/subscribe [:get [:product :how :user-info-explanation-text]])
                            :on-change #(rf/dispatch [::set-user-info-explanation-text %])}]]]
          [:div {:style {:margin-bottom "1rem"}}
           [extra-info-fields]]])])))

(defn- external-service []
  [:div
   [widgets/block-input
    {:id "registration-url"
     :label-text "URL zur Anmeldung bei externem Service"
     :value @(rf/subscribe [:get [:product :how :registration-url]])
     :required? true
     :validators [validation/allowed-link-types]
     :on-change #(rf/dispatch [:set-path [:product :how :registration-url] %])}]])

(rf/reg-sub ::access-code-ui-visible?
  :<- [:get [:options :partner-product?]]
  :<- [:get [:product :when :has-schedule?]]
  :<- [:get [:product :when :cohesion]]
  :<- [:get [:product :when :sessions-per-signup]]

  (fn [[options-partner-product? has-schedule? current-cohesion current-sessions-per-signup] _]
    (true? (and options-partner-product?
                (or (not has-schedule?)
                    (and (= current-cohesion :independent)
                         (= current-sessions-per-signup :multiple-sessions)))))))

(rf/reg-sub ::needs-access-code?
  :<- [::access-code-ui-visible?]
  :<- [:get [:product :how :needs-access-code?]]

  (fn [[access-code-ui-visible? needs-access-code?] _]
    (and needs-access-code? access-code-ui-visible?)))

(defn- participant-instructions []
  (let [partner-product? @(rf/subscribe [:get [:options :partner-product?]])
        path [:product :how :participant-instructions]
        participant-instructions' @(rf/subscribe [:get [:product :how :participant-instructions]])
        needs-access-code? @(rf/subscribe [::needs-access-code?])
        label-text (if partner-product?
                     "nach Buchung: Hinweise an Teilnehmer"
                     "nach Anmeldung: Hinweise an Teilnehmer")
        includes-code-text? (when-not (str/blank? participant-instructions')
                              (str/includes? participant-instructions' "CODE"))]
    [:div.col.s12 {:style {:padding-left 0 :margin-top "1rem"}}
     [:div.input-field
      [:label.active {:style {:padding-bottom "0.5rem"}}
       [:span label-text]]]
     [widgets/quill {:id "participant-instructions"
                     :value participant-instructions'
                     :style {:margin-top "1rem"}
                     :on-change #(rf/dispatch [:set-path path %])}]
     (when (> (count participant-instructions') (* 1000 100))
       [:span>i {:style {:color "red"}}
        "Die Hinweise an Teilnehmer sind zu groß. Es dürfen nur maximal 75kB verwendet werden. Benutzen Sie ggfs. besser komprimierte, weniger oder kleinere Bilder."])
     (when (and (not needs-access-code?) includes-code-text?)
       [:span.red-text "Im Hinweistext kommt CODE vor, es sind aber keine persönlichen Zugangscodes angegeben."])
     (when (and needs-access-code? (not includes-code-text?))
       [:span.red-text "CODE kommt im Hinweistext nicht vor."])

     [:div {:style {:margin-top "20px"}}
      "Diese Hinweise werden dem Teilnehmer in seiner " (if partner-product? "Buchungsbestätigung" "Anmeldebestätigung") " mitgeschickt."
      (when needs-access-code?
        [:<> [:br] "Im Text funktioniert CODE als Platzhalter, der durch den Zugangscode ersetzt wird."
         (when @(rf/subscribe [::product-form/machtfit-admin?])
           [:<>
            [:br]
            [:span
             "Einen Barcode im "
             [:a {:href "https://en.wikipedia.org/wiki/Interleaved_2_of_5" :target "_blank"} "ITF (interleaved 2 of 5)-Format"]
             " erhält man durch den Platzhalter BARCODE_ITF_WITH_TITLE. Der Barcode funktioniert nur mit Zahlen."]
            [:br]
            [:span
             "Einen Barcode im "
             [:a {:href "https://de.wikipedia.org/wiki/Code128" :target "_blank"} "Code128-Format"]
             " erhält man durch den Platzhalter BARCODE_CODE128_WITH_TITLE. Der Barcode funktioniert mit Ziffern, Groß- und Kleinbuchstaben, sowie Sonderzeichen."]
            [:br]
            [:span "Einen QR-Code erhält man durch den Platzhalter BARCODE_QR_WITH_TITLE."]])])]]))

(rf/reg-event-db ::set-access-codes
  (fn [db [_ access-codes]]
    (let [access-codes-warning-threshold-set-manually? (get-in db [:ui :access-codes-warning-threshold-set-manually?])]
      (cond-> db
        true (assoc-in [:product :how :access-codes] access-codes)
        (not access-codes-warning-threshold-set-manually?) (assoc-in
                                                            [:product :how :access-codes-warning-threshold]
                                                            (->> access-codes
                                                                 str/split-lines
                                                                 count
                                                                 (* 0.2)
                                                                 int))))))

(defn- access-code-name [access-codes]
  (if (validation/is-link? access-codes)
    "Zugangslink"
    "Zugangscode"))

(rf/reg-sub ::access-code-name
  :<- [:get [:product :how :access-codes]]

  (fn [access-codes _]
    (access-code-name access-codes)))

(rf/reg-event-db ::toggle-need-access-codes
  (fn [db _]
    (let [path [:product :how :needs-access-code?]
          active? (not (get-in db path))
          participant-instructions-path [:product :how :participant-instructions]
          participant-instructions' (get-in db participant-instructions-path)
          access-codes (get-in db [:product :how :access-codes])]
      (-> db
          (update-in path not)
          (assoc-in
           participant-instructions-path
           (if (and active? (not participant-instructions'))
             (str "Ihr persönlicher " (access-code-name access-codes) " lautet: CODE")
             participant-instructions'))))))

(rf/reg-event-db ::set-access-codes-warning-threshold
  (fn [db [_ threshold]]
    (-> db
        (assoc-in [:product :how :access-codes-warning-threshold] threshold)
        (assoc-in [:ui :access-codes-warning-threshold-set-manually?] true))))

(defn- access-codes []
  (let [needs-access-code? @(rf/subscribe [:get [:product :how :needs-access-code?]])
        access-codes' @(rf/subscribe [:get [:product :how :access-codes]])
        access-codes-used @(rf/subscribe [:get [:ui :access-codes-used]])
        access-code-name' @(rf/subscribe [::access-code-name])
        access-codes-count (if (str/blank? access-codes')
                             0
                             (count (str/split-lines access-codes')))]
    [:div {:style {:margin-bottom "2rem"}}
     [:input.filled-in {:type "checkbox"
                        :id "needs-access-code"
                        :checked needs-access-code?
                        :on-change #(rf/dispatch [::toggle-need-access-codes])}]
     [:label.black-text {:for "needs-access-code"
                         :style {:height "auto"
                                 :line-height "normal"}}
      "Teilnehmer erhalten persönlichen " access-code-name']
     (when needs-access-code?
       [:div
        [widgets/textarea {:id "access-codes"
                           :label-text [:span (str access-code-name' "s")
                                        [widgets/tooltip {:icon "icon-question-sign"
                                                          :content (str "Ein " access-code-name' " pro Zeile")}]]
                           :value access-codes'
                           :cleaner widgets/clean-list-of-strings
                           :on-save #(rf/dispatch [::set-access-codes %])}]
        [:p (str/join " " [access-codes-count
                           (str access-code-name' (when (not= access-codes-count 1) "s"))
                           "verfügbar,"
                           access-codes-used
                           (str "wurde" (when (not= access-codes-used 1) "n"))
                           "bereits vergeben."])]
        [:p
         "Erinnerung per E-Mail wenn nur noch"
         [widgets/inline-input {:value @(rf/subscribe [:get [:product :how :access-codes-warning-threshold]])
                                :on-save #(rf/dispatch [::set-access-codes-warning-threshold %])}]
         (str access-code-name' "s übrig sind.")]])]))

(rf/reg-sub ::how-section-complete?
  :<- [:get [:options :can-customize-registration?]]
  :<- [:get [:product :how :registration-needed?]]
  :<- [:get [:product :how :registration-type]]

  (fn [[can-customize-registration? registration-needed? registration-type'] _]
    (cond
      (not can-customize-registration?) true
      (false? registration-needed?) true
      (and (true? registration-needed?) (some? registration-type')) true)))

(defn section-how []
  (let [registration-needed? @(rf/subscribe [:get [:product :how :registration-needed?]])
        current-registration-type @(rf/subscribe [:get [:product :how :registration-type]])
        editable? @(rf/subscribe [::product-form/meta-editable?])
        can-customize-registration? @(rf/subscribe [:get [:options :can-customize-registration?]])
        complete? @(rf/subscribe [::how-section-complete?])]
    [widgets/section
     {:anchor "how"
      :title [review/highlighted-section-title :how "Wie"]
      :subtitle [:div "nimmt man teil?"
                 [review/field-badges :how]]
      :content [:div
                [:div.col.s12
                 (if can-customize-registration?
                   [:div
                    (if editable?
                      [registration-needed]
                      [registration-configuration-ro])
                    (when (and editable? registration-needed?)
                      [registration-type])
                    (when registration-needed?
                      (case current-registration-type
                        :machtfit [require-user-info]
                        :url [external-service]
                        nil))]
                   [require-user-info])
                 (when @(rf/subscribe [::access-code-ui-visible?])
                   [access-codes])
                  ;; should be always at the bottom of this component
                 (when (= current-registration-type :machtfit)
                   [participant-instructions])]
                (when complete?
                  [show-next-section :how])]}]))
